import React, { useEffect, useMemo, useState } from "react";
import {
    getEmptyTopicChoice,
    getEmptyTopicCompound,
    getPaper,
    getWeekTimePaper,
    PaperParams,
    TopicType,
    topicTypeSort
} from "../../../service/homework";
import useRequest from "../../../utils/useRequest";
import {
    getCourseNameByCourseNo2,
    getTypeSort,
    isTrue,
    QuestionType,
    SortType
} from "../../../service/service";
import { Alert, Empty, message, Spin } from "antd";
import _ from "underscore";
import Header from "../../../components/Header";
import HomeworkContext from "./context";
import HomeworkLayout from "../component/layout";
import EditDanXuan from "./components/EditDanXuan";
import EditDuoxuan from "./components/EditDuoxuan";
import EditPanDuan from "./components/EditPanDuan";
import EditZhuguan from "./components/EditZhuguan";
import EditTianKong from "./components/EditTiankong";
import EditCompound from "./components/EditCompound";
import style from "../../exam/addExam/addExam.module.scss";
import styles from "./index.module.scss";
import HomeworkEditWidget from "./components/HomeworkEditWidget";
// import editStyle from "./index.module.scss";
import LoadingWrapper from "../../../components/LoadingWrapper";
import classNames from "classnames";
import useRequestFn from "../../../utils/useRequestFn";

interface PageAddExamProps {
    match: { params: PaperParams };
}

export interface OrderTopicType extends TopicType {
    order?: number;
}

const examTypeList = [
    QuestionType.DanXuan,
    QuestionType.DuoXuan,
    QuestionType.PanDuan,
    QuestionType.ZhuGuan,
    QuestionType.TianKong,
    QuestionType.TingLi,
    QuestionType.WanXingTianKong,
    QuestionType.YueDuLiJie
];

export default function PageEditHomework({
    match: { params }
}: PageAddExamProps) {
    const [paperData, { loading }, loadPaperData] = useRequest(() =>
        getPaper(params)
    );
    const [courseName] = useRequest(() =>
        getCourseNameByCourseNo2(params.courseNo, params.courseSeq)
    );

    const [getHomeWorkTypeList, { loading: sortLoading }] =
        useRequestFn(getTypeSort);

    const [topics, setTopics] = useState<OrderTopicType[]>([]);
    const [topicTypes, setTopicTypes] = useState<QuestionType[]>([]);
    const [newTopic, setNewTopic] = useState("");

    const [homework, { loading: canLoading }] = useRequest(
        () => getWeekTimePaper(parseInt(params.weekTimeId)),
        {},
        [params.weekTimeId]
    );

    useEffect(() => {
        if (!paperData) {
            return setTopicTypes(examTypeList);
        }
        if (paperData.topics.length !== 0) {
            const topics: OrderTopicType[] = [...paperData.topics];
            const topicGroup = _.groupBy(
                paperData.topics,
                topic => topic.topicType
            );
            topics.map(topic => {
                const list = topicGroup[topic.topicType];
                topic.order = list.findIndex(item => item === topic);
                return topic;
            });
            setTopics(topics);
        }
        getHomeWorkTypeList(SortType.HomeWork, paperData?.id || 0).then(res => {
            setTopicTypes(res.split(",") as QuestionType[]);
        });
    }, [paperData]);

    const handleSortType = (topicTypes: QuestionType[], sort: boolean) => {
        setTopicTypes(topicTypes);
        sort && topicTypeSort(paperData?.id!, topicTypes);
    };

    const [isPublish, isHomeworkComplete, lockEdit] = useMemo(() => {
        return [
            isTrue(paperData?.ispublish),
            isTrue(paperData?.isHomeworkComplete),
            isTrue(paperData?.isHomeworkComplete) ||
                isTrue(paperData?.ispublish)
        ];
    }, [paperData]);

    // 试卷加载时的提示
    useEffect(() => {
        isHomeworkComplete && message.warn("学生已经开始答题, 锁定更改操作!");
    }, [isHomeworkComplete]);

    // 添加试题
    const addTopic = (type: QuestionType) => {
        if (lockEdit) return; // 如果有学员答题则不允许修改

        let topic: OrderTopicType;
        if (
            type ===
            (QuestionType.TingLi ||
                QuestionType.WanXingTianKong ||
                QuestionType.YueDuLiJie)
        ) {
            topic = getEmptyTopicCompound(type);
        } else {
            topic = getEmptyTopicChoice(type);
        }

        setTopics([...topics, topic]);
        setNewTopic(`${topic.topicId || topic.tempTopicId}`);
    };

    useEffect(() => {
        if (!newTopic) return;
        const interval = setInterval(() => {
            let anchorElement = document.getElementById(newTopic);
            if (anchorElement) {
                anchorElement.scrollIntoView();
                clearInterval(interval);
            }
        }, 100);
    }, [newTopic]);

    // 试题内容更改
    const onTopicChange = (index: number, topic: OrderTopicType) => {
        const newTopics = [...topics];
        const topicIndex = newTopics.findIndex(
            item => item.tempTopicId === topic.tempTopicId
        );
        topic.order = newTopics[topicIndex].order;
        newTopics[topicIndex] = { ...newTopics[topicIndex], ...topic };
        setTopics(newTopics);
    };

    return (
        <div>
            <Header style={{ marginBottom: 0 }} />

            <div
                className={classNames(
                    isTrue(homework?.readOnly) && styles.over,
                    styles.mt
                )}>
                {isTrue(homework?.readOnly) && (
                    <Alert
                        className={styles.alert}
                        message="仅授课教师可编辑"
                        type="info"
                        showIcon
                    />
                )}
                <LoadingWrapper loading={loading || canLoading} isEmpty={false}>
                    {() => (
                        <HomeworkContext.Provider
                            value={{
                                paperId: String(homework?.paperId),
                                paperParams: params,
                                lockEdit,
                                isPublish,
                                isHomeworkComplete,
                                topics,
                                setTopics,
                                addTopic,
                                loadPaperData
                            }}>
                            <HomeworkLayout
                                left={
                                    <Spin spinning={sortLoading}>
                                        <HomeworkEditWidget
                                            paperData={paperData}
                                            examName={courseName || ""}
                                            sortType={handleSortType}
                                            examTypeList={topicTypes}
                                        />
                                    </Spin>
                                }
                                main={
                                    <div className={styles.main}>
                                        {topicTypes.map(type => {
                                            return _.chain(topics)
                                                .filter(
                                                    topic =>
                                                        topic.topicType === type
                                                )
                                                .sortBy(topic => topic.order)
                                                .map((item, index) => (
                                                    <div
                                                        key={`${
                                                            item.topicId ||
                                                            item.tempTopicId
                                                        }`}
                                                        id={`${
                                                            item.topicId ||
                                                            item.tempTopicId
                                                        }`}>
                                                        {item.topicType ===
                                                            QuestionType.DanXuan && (
                                                            <EditDanXuan
                                                                topic={item}
                                                                onChange={topic =>
                                                                    onTopicChange(
                                                                        index,
                                                                        topic
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                        {item.topicType ===
                                                            QuestionType.DuoXuan && (
                                                            <EditDuoxuan
                                                                topic={item}
                                                                onChange={topic =>
                                                                    onTopicChange(
                                                                        index,
                                                                        topic
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                        {item.topicType ===
                                                            QuestionType.PanDuan && (
                                                            <EditPanDuan
                                                                topic={item}
                                                                onChange={topic =>
                                                                    onTopicChange(
                                                                        index,
                                                                        topic
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                        {item.topicType ===
                                                            QuestionType.ZhuGuan && (
                                                            <EditZhuguan
                                                                topic={item}
                                                                onChange={topic =>
                                                                    onTopicChange(
                                                                        index,
                                                                        topic
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                        {item.topicType ===
                                                            QuestionType.TianKong && (
                                                            <EditTianKong
                                                                topic={item}
                                                                onChange={topic =>
                                                                    onTopicChange(
                                                                        index,
                                                                        topic
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                        {item.topicType ===
                                                            QuestionType.TingLi && (
                                                            <EditCompound
                                                                topic={item}
                                                                onChange={topic =>
                                                                    onTopicChange(
                                                                        index,
                                                                        topic
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                        {item.topicType ===
                                                            QuestionType.WanXingTianKong && (
                                                            <EditCompound
                                                                topic={item}
                                                                onChange={topic =>
                                                                    onTopicChange(
                                                                        index,
                                                                        topic
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                        {item.topicType ===
                                                            QuestionType.YueDuLiJie && (
                                                            <EditCompound
                                                                topic={item}
                                                                onChange={topic =>
                                                                    onTopicChange(
                                                                        index,
                                                                        topic
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                ))
                                                .value();
                                        })}
                                        {topics.length === 0 && (
                                            <div className={style.Empty}>
                                                <Empty description="您还没有添加试题" />
                                            </div>
                                        )}
                                        {lockEdit && (
                                            <div className={styles.cover}>
                                                {/* {isHomeworkComplete && "当前作业已有学生作答，禁止修改！"} */}
                                                {/* {!isHomeworkComplete && isPublish && "当前作业禁止修改，请取消发布！"} */}
                                            </div>
                                        )}
                                    </div>
                                }
                            />
                        </HomeworkContext.Provider>
                    )}
                </LoadingWrapper>
            </div>
        </div>
    );
}
